export default __webpack_public_path__ + "static/media/step4.8e33a306.mov";